<template>
  <div class="program">
    <ul class="programlist">
      <li v-for="item in classArr">
        <div class="time">
          {{item.start}}-{{item.end}}
        </div>
        <div class="name">
          <span>{{item.nickname}}</span>
          {{item.title}}
        </div>
        <div class="back" @click="goplay(item.url)" v-if="item.status===3">{{ item.status | formatStatus}}</div>
        <div :class="item.status === 1?'living':'back'" v-else>{{item.status | formatStatus}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import service from '../js/getmsg'
export default {
  name: "Program",
  filters: {
    formatStatus: function (value) {
      return value === 1 ? '直播中' : value === 2 ? '尚未开始' : '回看';
    }
  },
  data() {
    return {
      classArr: service.classArr,
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/zb/components/Program.vue